export default __webpack_public_path__ + "images/0bcb5765abe0b194cfa57c3017294775.jpg";